// extracted by mini-css-extract-plugin
var _1 = "takeover-desktop__ef_4y";
var _2 = "takeover-header-no-border__WPfmf";
var _3 = "takeover-mobile__lMi6h";
var _4 = "takeover-theme-grey__IdWdB";
var _5 = "takeover-theme-white__cEfRi";
var _6 = "takeover-theme-white-smooth__E28Iw";
export { _1 as "takeoverDesktop", _2 as "takeoverHeaderNoBorder", _3 as "takeoverMobile", _4 as "takeoverThemeGrey", _5 as "takeoverThemeWhite", _6 as "takeoverThemeWhiteSmooth" }
